import { render, staticRenderFns } from "./BaseTSRView.vue?vue&type=template&id=17713703"
import script from "./BaseTSRView.vue?vue&type=script&lang=js"
export * from "./BaseTSRView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports